<div class="row">
  <div class="col-12 mb-5 col-sm-6">
    <h1>Platform / Switch</h1>
  </div>
</div>

<div class="form">
  <form [formGroup]="form">
    <div class="row">
      <div class="col-6 ui-platform-form-control">
        <ui-platform-switch
          formControlName="switch"
          [label]="'Switch toggle'">
        </ui-platform-switch>
      </div>
    </div>

    <div class="row">
      <div class="col-6 ui-platform-form-control">
        <ui-platform-switch
          formControlName="switchDefaultFalse"
          [label]="'Profile visible to public (be default false)'">
        </ui-platform-switch>
      </div>
    </div>

    <div class="row">
      <div class="col-6 ui-platform-form-control">
        <ui-platform-switch
          formControlName="switchDisabled"
          [disabled]="true"
          [label]="'Switch toggle disabled'">
        </ui-platform-switch>
      </div>
    </div>
  </form>
</div>

<div class="row">
  <div class="col-8">
    <h2>Code</h2>
    <p>Declare module:</p>
    <pre>{{ import }}</pre>
    <p>Use component in a template:</p>
    <pre>{{ usage }}</pre>
    <p><i>Note: display of errors in not part of a component, implemented as ui-platform-form-control classes</i></p>
  </div>
</div>
